import React from 'react'
import * as Sentry from '@sentry/browser'
import MainContent from './MainContent'
import { GeneralAppStorageContextProvider } from './app/GeneralAppStorageContext'
import LookupContextProvider from './app/LookupContext'
import { PermissionsProvider } from './app/PermissionsContext'
import { RoleIndicatorRefProvider } from './app/RoleIndicatorRefContext'
import Spinner from './app/Spinner'
import { PageTitleProvider } from './app/PageTitleContext'
import useReportModal from '../hooks/useReportModal'
import { createSentryAdapter } from '../util/SentryReportAdapter'
import ReportModal from './report/ReportModal'

const submitToSentry = createSentryAdapter(Sentry)

function ReportModalTrigger() {
  const { isOpen, triggerMessage, closeModal } = useReportModal()
  return isOpen ? (
    <ReportModal onClose={closeModal} onSubmit={(report) => submitToSentry({ ...report, message: triggerMessage })} />
  ) : null
}

export default function App() {
  return (
    <PermissionsProvider>
      <LookupContextProvider>
        <GeneralAppStorageContextProvider>
          <RoleIndicatorRefProvider>
            <Spinner />
            <ReportModalTrigger />
            <PageTitleProvider>
              <MainContent />
            </PageTitleProvider>
          </RoleIndicatorRefProvider>
        </GeneralAppStorageContextProvider>
      </LookupContextProvider>
    </PermissionsProvider>
  )
}
